import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "notification--error"
}
const _hoisted_2 = { key: 2 }

import { onMounted } from "vue";
import { useWizardStepsService } from "./services/wizardStepsService";
import { useWizardStepsStore } from "./store/wizardStepsStore";
import { StepType } from "@features/Pages/WizardStepsPage/_js/App/types/stepType";
import Spinner from '@components/Spinner/Spinner.vue';
import PreviousStep from "@features/Pages/WizardStepsPage/_js/App/components/PreviousStep.vue";
import Step from './components/Step.vue';
import Result from "@features/Pages/WizardStepsPage/_js/App/components/Result.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useWizardStepsStore();
const wizardStepsService = useWizardStepsService()

const errorMessage = (document.getElementById("errorMessage") as HTMLInputElement).value;

onMounted(() => {
  wizardStepsService.getPageTree();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).loading)
      ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_unref(store).error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(errorMessage)), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (!_unref(store).loading && !_unref(store).error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_TransitionGroup, {
            appear: "",
            name: "fade"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).previousSteps, (step, index) => {
                return (_openBlock(), _createBlock(PreviousStep, {
                  key: step.id,
                  step: step,
                  index: index
                }, null, 8 /* PROPS */, ["step", "index"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }),
          (_unref(store).currentStep.stepType === _unref(StepType).Question || _unref(store).currentStep.stepType === _unref(StepType).Answer)
            ? (_openBlock(), _createBlock(Step, { key: 0 }))
            : _createCommentVNode("v-if", true),
          (_unref(store).currentStep.stepType === _unref(StepType).Result)
            ? (_openBlock(), _createBlock(Result, { key: 1 }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})